import { APP_ROUTES, useAppSelector, useAppTranslation } from "@/utils";
import { CloseCircleFilled, PhRArrowCounterClockwise } from "@payping/icons";
import { Button, Flex, Typography } from "@payping/web-components";
import { Link } from "react-router";

const EpaPaymentCallbackFailedPage = () => {
  const { t } = useAppTranslation();
  const order = useAppSelector((state) => state.bnplConsumer.order);
  const trackingCode = useAppSelector((state) => state.dashboardPersist.trackingCode);

  return (
    <Flex vertical className="tw:h-full tw:w-full tw:p-4!" gap={"middle"} align="center" justify="center">
      <Flex vertical align="center" justify="center" gap={"large"} className="tw:my-auto tw:w-full">
        <CloseCircleFilled width={80} className="tw:fill-color-error" />
        <Flex vertical gap={"small"} align="center" justify="center">
          <Typography.Title level={5} className="tw:m-0! tw:font-semibold!">
            {t("pay.getOrder.steps.payPromissory.paymentRejectTitle")}
          </Typography.Title>
          <Typography.Text type="secondary" className="tw:text-center">
            {t("pay.getOrder.steps.payPromissory.paymentRejectContent")}
          </Typography.Text>
        </Flex>

        <Link to={`${APP_ROUTES.pay.getOrder.root.url}?trackingCode=${trackingCode}`}>
          <Button icon={<PhRArrowCounterClockwise width={14} height={14} />} type="link">
            {t("common.retry")}
          </Button>
        </Link>
      </Flex>

      <Flex align="center" className="tw:mt-auto tw:w-full" gap={"middle"}>
        {order.merchantRedirectUrl ? (
          <Button block type="default">
            <a href={order.merchantRedirectUrl}>
              {order.merchantName ? t("common.returnTo", { name: order.merchantName }) : t("common.returnToShop")}
            </a>
          </Button>
        ) : null}
      </Flex>
    </Flex>
  );
};

export default EpaPaymentCallbackFailedPage;
